const topics = [
  { id: 1, name: '国产新片推荐', heat: '9.8万讨论', hot: true },
  { id: 2, name: '高分口碑佳作', heat: '7.6万讨论', hot: true },
  { id: 3, name: '91免费在线视频', heat: '6.2万讨论', hot: true },
  { id: 4, name: '剧情片精选', heat: '5.4万讨论', hot: false },
  { id: 5, name: '91精品视频在线', heat: '8.1万讨论', hot: true },
  { id: 6, name: '悬疑烧脑合集', heat: '4.3万讨论', hot: false },
  { id: 7, name: '经典老片修复', heat: '3.9万讨论', hot: false },
  { id: 8, name: '91在线观看免费', heat: '7.2万讨论', hot: true },
  { id: 9, name: '爱情文艺专场', heat: '5.8万讨论', hot: false },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="section-scroll py-14 md:py-20 bg-gray-50/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <p className="text-red-600 text-xs md:text-sm font-semibold tracking-widest uppercase mb-2">热议焦点</p>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900">热门话题</h2>
          <p className="mt-2 text-gray-500 text-sm md:text-base max-w-lg mx-auto">
            当下最受关注的91免费视频网站热门讨论，总有一个你感兴趣的
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 md:gap-4 max-w-4xl mx-auto">
          {topics.map((topic) => (
            <a
              key={topic.id}
              href="#topics"
              onClick={(e) => e.preventDefault()}
              className={`group flex items-center gap-2 px-4 py-2.5 md:px-5 md:py-3 rounded-full border cursor-pointer transition-all duration-300 hover:scale-105 ${
                topic.hot
                  ? 'bg-red-50 border-red-200 hover:border-red-400 hover:bg-red-100'
                  : 'bg-white border-gray-200 hover:border-gray-300 hover:bg-gray-100'
              }`}
            >
              {topic.hot && (
                <span className="flex-shrink-0 w-5 h-5 md:w-6 md:h-6 flex items-center justify-center">
                  <i className="ri-fire-line text-red-500 text-sm md:text-base"></i>
                </span>
              )}
              <span className={`text-sm md:text-base font-medium whitespace-nowrap ${
                topic.hot ? 'text-red-700' : 'text-gray-700'
              }`}>
                #{topic.name}
              </span>
              <span className={`text-xs whitespace-nowrap ${
                topic.hot ? 'text-red-400' : 'text-gray-400'
              }`}>
                {topic.heat}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}